function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { CANADIAN_STATES, US_STATES, US_STATES_AND_TERRITORIES } from "@vestwell-frontend/helpers";
import { FormDropdown } from "@vestwell-frontend/ui";
import { useMemo } from "react";
export var StatesDropdown = function(_param) {
    var _param_country = _param.country, country = _param_country === void 0 ? 'US_AND_TERRITORIES' : _param_country, _param_displayFormat = _param.displayFormat, displayFormat = _param_displayFormat === void 0 ? 'short' : _param_displayFormat, _param_width = _param.width, width = _param_width === void 0 ? 36 : _param_width, props = _object_without_properties(_param, [
        "country",
        "displayFormat",
        "width"
    ]);
    var options = useMemo(function() {
        return Object.entries(country === 'US_AND_TERRITORIES' ? US_STATES_AND_TERRITORIES : country === 'US' ? US_STATES : CANADIAN_STATES).reduce(function(acc, param) {
            var _$_param = _sliced_to_array(param, 2), key = _$_param[0], value = _$_param[1];
            return _to_consumable_array(acc).concat([
                {
                    label: displayFormat === 'short' ? key : value,
                    value: key
                }
            ]);
        }, []);
    }, [
        country,
        displayFormat
    ]);
    return /*#__PURE__*/ _jsx(FormDropdown, _object_spread_props(_object_spread({}, props), {
        options: options,
        width: width
    }));
};

//# sourceMappingURL=data:application/json;base64,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